module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qnerv8-cc2b509fcae26a61e29198219f19aedd.jpg";